import {list, removeRemetente} from '@/domain/marketing/services/remetente'
import window from './window/window.js'

export default {
  pageTitle: 'Remetentes',
  columns: [
    {
      name: 'canal',
      required: true,
      label: 'Canal',
      align: 'left',
      field: 'canal',
      sortable: true,
      parser: function (props) {
        return props.canal.toUpperCase()
      }
    },
    {
      name: 'nome',
      required: true,
      label: 'Nome',
      align: 'left',
      field: 'nome',
      sortable: true,
      parser: function (props) {
        return props.nome
      }
    },
    {
      name: 'remetente',
      required: true,
      label: 'Remetente',
      align: 'left',
      field: 'remetente',
      sortable: true,
      parser: function (props) {
        return props.remetente
      }
    },
    {
      name: 'active',
      required: true,
      label: 'Situação',
      align: 'left',
      field: 'active',
      sortable: true,
      parser: function (props) {
        return props.active ? 'Ativo' : 'Inativo'
      }
    },
    {
      name: 'options',
      required: true,
      label: '',
      field: 'options',
      sortable: false
    }
  ],
  resolve: list,
  methods: {
    // window: window
    abrir: function (id) {
      window.call(this, {id: id, table: this.table})
    },
    novo: function () {
      window.call(this, {})
    },
    excluir: removeRemetente
  }
}
